<template>
  <div class="sidebar">
    <div class="box1" @click="pathIndex">
      <img :src="handleImgUrl1" alt />
    </div>

    <div class="box2" :class="viewType == '01' ? 'textColor1' : 'textColor2'">
      <div v-for="item in links" :key="item.name" @click="changePage(item.id, item.is_type)">{{ item.name }}</div>
    </div>
    <div class="box3">
      <!-- 购票参会 -->
      <CusButton class="opt-btn" :class="{'btn-en': $route.params.lang == 'en'}" txtColor="white" color="blue" @click="gbclick()" v-if="showByTicketBtn">
        <img class="icon" src="./../assets/icon/buy_ticker_icon.png" />
        <span>{{ $t("Tickets") }}</span>
      </CusButton>
      <!-- 成为合作伙伴 -->
      <CusButton class="opt-btn " :class="{'btn-en': $route.params.lang == 'en'}" txtColor="white" color="pink" @click="b2Parentclick()" v-if="showByHezuoBtn">
        <img class="icon" src="./../assets/icon/b2speaker.png" />
        <span>{{ $t("Partner") }}</span>
      </CusButton>
      <!-- 直播回看 -->
      <CusButton class="opt-btn" :class="{'btn-en': $route.params.lang == 'en'}" txtColor="white" color="purple" @click="changePage(16, liveBackUnLock ? 1 : 0)" v-if="showPlayBackBtn">
        <img class="icon" src="./../assets/icon/live.png" />
        <span>{{ $t("review") }}</span>
      </CusButton>
      <!-- 观看直播 -->
      <CusButton class="opt-btn" :class="{'btn-en': $route.params.lang == 'en'}" txtColor="white" color="purple" @click="changePage(15, liveUnLock ? 1 : 0)" v-if="showLiveBtn">
        <img class="icon" src="./../assets/icon/live.png" />
        <span>{{ $t("Livestream") }}</span>
      </CusButton>

      <div class="con3" :class="viewType == '01' ? 'textColor1' : 'textColor2'"
        style="cursor: pointer; margin-top: .3rem;" @click="swichLang">
        <img :src="handleImgUrl2" alt />
        <span>{{ lang === "en" ? "ZH" : "EN" }}</span>
      </div>
    </div>
    <div class="box4">
      <div class="b4_top">
        <img :src="handleImgUrl3" @mousemove="wcmove" @mouseleave="wxeave" alt />
        <img @click="wb" :src="handleImgUrl4" alt />
        <img v-copy="yxdz" @click="yx" :src="handleImgUrl5" alt />
        <img @click="gw" :src="handleImgUrl6" alt />
        <div class="bo_right_center" :class="{ invisible: value }">
          <img src="@/assets/footer/img28.png" alt />
        </div>
      </div>
      <div class="addr" :class="viewType == '01' ? 'textColor1' : 'textColor2'">
        <div>{{$t("Eventaddress")}}:</div>

        <p>{{$t("address")}}</p>
      </div>
    </div>
    <BulletFrame v-if="ifyjjb" @show="showPh" />
  </div>
</template>

<script>
import BulletFrame from "../components/BulletFrame.vue";
import CusButton from "@/components/CusButton.vue";
import { getWindowSize } from "@/utils/index";
import { setStatisticList } from "@/components/setStatistic";
import { changeUrlLang } from "@/utils/index";
import { BusCooperation } from "@/utils/links";

export default {
  name: "LayoutSide",
  components: {
    BulletFrame,
    CusButton
  },
  data() {
    return {
      ifyjjb: false,
      yxdz: "summit@blockchainlabs.org",
      value: true,
      liveBackUnLock: false, //直播回看是否锁定
      liveUnLock: true, //直播是否锁定
      ticketUnLock: false,//购票是否锁定
      hezuoUnLock: false, //合作伙伴是否锁定
      showByTicketBtn: false,
      showPlayBackBtn: false,
      showLiveBtn: false,
      showByHezuoBtn: false,
      links: []
    };
  },
  props: {
    viewType: { type: String, required: true, default: "01" },
    navList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
  },
  methods: {
    changePage(id, type) {
      if (type == 1) {
        window.scrollTo({
          top: 0,
          left: 0
        });
        this.$router.push({
          name:
            id == 4
              ? "Partners"
              : id == 3
                ? "SideEvent"
                : id == 2
                  ? "Agenda"
                  : id == 1
                    ? "Speakers"
                    : id == 15
                      ? "Live"
                      : "LiveReview"
        });
      } else {
        this.ifyjjb = true;
      }
    },

    showPh(flag) {
      this.ifyjjb = flag;
    },
    swichLang() {
      let l = this.$route.params.lang || "zh";
      let nextLang = this.$route.params.lang === "en" ? "zh" : "en";
      sessionStorage.setItem("Language", nextLang == "zh" ? "cn" : "en");
      changeUrlLang(l);
    },
    gbclick() {
      if (!this.ticketUnLock) {
        this.ifyjjb = true;
      } else {
        setStatisticList("3", getWindowSize() <= 640 ? "2" : "1");
        let zhurl = "https://9424105689699.huodongxing.com/event/7808935150100";
        let enurl = "https://9424105689699.huodongxing.com/event/7808935150100";
        window.open(this.lang == "zh" ? zhurl : enurl, "_blank");
      }
    },
    b2Parentclick(){
      if(!this.hezuoUnLock) {
        this.ifyjjb = true;
        return
      }
      window.open(BusCooperation, "_blank");
    },
    pathIndex() {
      let l = this.$route.params.lang;
      this.$router.push({
        name: "ArrNoRepeat",
        params: {
          lang: l
        }
      });
    },
    wcmove() {
      this.value = false;
    },
    wxeave() {
      this.value = true;
    },
    wb() {
      let url = "https://weibo.com/u/6289408183";
      window.open(url, "_blank");
    },
    yx() { },
    gw() {
      let url = "https://www.blockchainlabs.org/#/home";
      window.open(url, "_blank");
    }
  },
  watch: {
    navList() {
      if (!this.navList) {
        this.links = []
      }
      const list = []
      this.navList.forEach(el => {
        const element = Object.assign({}, el);
        if (element.is_but == 0) {
          list.push(element);
        }
        if (element.id == 14) {
          this.showByTicketBtn = true;
          this.ticketUnLock = element.is_type == 1 ? true : false;
        }
        if (element.id == 16) {
          this.showPlayBackBtn = true;
          this.liveBackUnLock = element.is_type == 1 ? true : false;
        }
        if (element.id == 15) {
          this.showLiveBtn = true;
          this.liveUnLock = element.is_type == 1 ? true : false;
        }
        if(element.id == 26){
          this.showByHezuoBtn = true;
          this.hezuoUnLock = element.is_type == 1 ? true : false;
        }
        return element;
      });
      this.links = list;
    }
  },
  computed: {
    lang() {
      return this.$route.params.lang || "zh";
    },
    handleImgUrl1() {
      const url =
        this.viewType == "01"
          ? require("@/assets/sidebar/box.png")
          : require("@/assets/sidebar/box_2.png");
      return url;
    },
    handleImgUrl2() {
      const url =
        this.viewType == "01"
          ? require("@/assets/sidebar/icon1.png")
          : require("@/assets/sidebar/icon1_2.png");
      return url;
    },
    handleImgUrl3() {
      const url =
        this.viewType == "01"
          ? require("@/assets/icon/wechart_white.webp")
          : require("@/assets/icon/wechart.webp");
      return url;
    },
    handleImgUrl4() {
      const url =
        this.viewType == "01"
          ? require("@/assets/icon/weibo_white.webp")
          : require("@/assets/icon/weibo.webp");
      return url;
    },
    handleImgUrl5() {
      const url =
        this.viewType == "01"
          ? require("@/assets/icon/message_white.webp")
          : require("@/assets/icon/message.webp");
      return url;
    },
    handleImgUrl6() {
      const url =
        this.viewType == "01"
          ? require("@/assets/icon/house_white.webp")
          : require("@/assets/icon/house.webp");
      return url;
    },
    handleImgUrl7() {
      const url =
        this.viewType == "01"
          ? require("@/assets/sidebar/icon6.png")
          : require("@/assets/sidebar/icon6_2.png");
      return url;
    }
  }
};
</script>

<style lang="less" scoped>
.sidebar {
  padding: 0.15rem 0.2rem 0 0.26rem;
  box-sizing: border-box;
}

.invisible {
  visibility: hidden;
}

.bo_right_center {
  position: absolute;
  left: 0;
  top: 50px;
}

.box1 {
  display: flex;
}

.box1>img {
  /* width: 220px;
    height: 100px; */
  width: 100%;
  cursor: pointer;
  margin-top: 0.35rem;
}

.box2 {
  margin: 0.5rem 0;
}

.box2>div {
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-weight: 600;
  font-size: 0.14rem;
  line-height: 0.4rem;
  cursor: pointer;
}

.box3 .icon {
  display: inline-bUnLock;
  height: 0.2rem;
  width: 0.2rem;
  margin-right: 0.1rem;
}

.box3 .opt-btn {
  margin-bottom: 0.1rem;
  width: 80%;
  &.btn-en{
    padding: 0 0.1rem;
    img{
      width: .18rem;
      height: .18rem;
      margin-right: .05rem;
    }
    span{
      font-size: .12rem;
    }
  }
}

.box3 .con3 {
  // margin-top: .2rem;
  font-size: 0;
}

.box3 .box3_buy {
  width: 1rem;
  min-width: 186px;
}

.box3 .con3>img {
  width: 0.2rem;
  height: 0.2rem;
  vertical-align: middle;
  margin-right: 0.1rem;
}

.box3 .con3>span {
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-size: 0.14rem;
  vertical-align: middle;
}

.box4 .b4_top {
  display: flex;
  margin-top: 0.3rem;
  margin-bottom: 0.2rem;
  position: relative;
}

.box4 .b4_top>img {
  margin-right: 0.1rem;
  width: 0.3rem;
  height: 0.3rem;
  min-width: 22px;
  min-height: 22px;
}

.box4 .b4_bottom {
  font-size: 0.14rem;
  font-weight: 600;
  font-family: SourceHanSansSC, SourceHanSansSC;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.box4 .addr{
  font-size: 0.14rem;
}

.b4_bottom>div {
  margin-bottom: 0.15rem;
}

.dress_icon {
  vertical-align: bottom;
  margin-right: 0.1rem;
  width: 0.2rem;
  height: 0.25rem;
}

.textColor1 {
  color: #fff !important;
}

.textColor2 {
  color: #333 !important;
}
</style>
